import ReactDOMServer from 'react-dom/server';
import CustomMarker from './CustomMarker';

const createCompositeKey = (place) => `${place.name}_${place.latitude}_${place.longitude}`;

export const createCustomMarker = (
  googleMapsAPI,
  googleMap,
  place,
  showPlaceInfoBox,
  color,
  columnId,
  fetchPlaceDetailsWrapper,
  placesService,
  pullDataOnClick = false,
  markerType = 'generic'
) => {
  if (!googleMapsAPI?.marker?.AdvancedMarkerElement || !googleMap) {
    return;
  }
  const markerElement = document.createElement('div');
  markerElement.innerHTML = ReactDOMServer.renderToString(<CustomMarker color={color} type={markerType} />);
  const lat = place.latitude;
  const lng = place.longitude;
  if (typeof lat !== 'number' || typeof lng !== 'number') {
    return;
  }
  const marker = new googleMapsAPI.marker.AdvancedMarkerElement({
    map: googleMap,
    position: { lat, lng },
    content: markerElement,
  });
  marker.placeId = place.google_place_id || place.place_id || '';
  marker.columnId = columnId;
  marker.placeName = place.name;
  marker.placeLatitude = lat;
  marker.placeLongitude = lng;
  marker.pullDataOnClick = pullDataOnClick;
  marker.addListener('gmp-click', async (e) => {
    if (marker.placeDetails) {
      showPlaceInfoBox(marker.placeDetails);
    } else if (marker.pullDataOnClick && fetchPlaceDetailsWrapper && marker.placeId) {
      try {
        const placeDetails = await fetchPlaceDetailsWrapper(marker.placeId);
        if (placeDetails) {
          marker.placeDetails = placeDetails;
          showPlaceInfoBox(placeDetails);
        }
      } catch (error) {
      }
    } else {
      showPlaceInfoBox(place);
    }
  });
  return marker;
};

export const clearMarkers = (markers) => {
  if (!markers) {
    return;
  }
  markers.forEach((marker) => {
    if (marker) {
      marker.setMap(null);
    }
  });
  markers.clear();
};

const removeDuplicateMarkers = (place, markersRef) => {
  const key = createCompositeKey(place);
  const marker = markersRef.current.get(key);
  if (marker) {
    removeSingleMarker(place, markersRef);
  }
};

export const addSingleMarker = (
  googleMapsAPI,
  googleMap,
  place,
  showPlaceInfoBox,
  markersRef,
  color,
  columnId,
  fetchPlaceDetailsWrapper,
  placesService,
  pullDataOnClick = false,
  markerType = 'generic'
) => {
  removeDuplicateMarkers(place, markersRef);
  const marker = createCustomMarker(
    googleMapsAPI,
    googleMap,
    place,
    showPlaceInfoBox,
    color,
    columnId,
    fetchPlaceDetailsWrapper,
    placesService,
    pullDataOnClick,
    markerType
  );
  if (!marker) return;
  const key = createCompositeKey(place);
  markersRef.current.set(key, marker);
};

export const removeSingleMarker = (place, markersRef) => {
  const compositeKey = createCompositeKey(place);
  const marker = markersRef.current.get(compositeKey);
  if (marker) {
    marker.setMap(null);
    markersRef.current.delete(compositeKey);
  }
};

export const clearColumnMarkers = (columnId, markersRef) => {
  markersRef.current.forEach((marker, key) => {
    if (marker.columnId === columnId) {
      marker.setMap(null);
      markersRef.current.delete(key);
    }
  });
};
